import { useState } from 'react';
import PropTypes from 'prop-types';
import { Label } from 'ypf-pas-general-ui-components';

import { TypeAndObjectImputationPermissions } from '../RequestDetailTypes';
import WorkReportLineMenu from '../../WorkReports/WorkReportActionButtons/WorkReportLineMenu/WorkReportLineMenu';
import './CustomAccordion.scss';

const RightContentAccordion = ({
  byUbication,
  disabledDeleteAction,
  IOPermissions,
  isOrderByUbication,
  isFinishedServiceAvailable,
  setOpenModal,
  setShowDeleteModal,
  setShowFinishedServiceModal,
  handleUpdateDeleteUbicationInfo,
  handleSetFinishedServiceInfo
}) => {
  const [showModalMenu, setShowModalMenu] = useState(false);
  const canSeeImputationDetails = byUbication && IOPermissions.visualize;

  return (
    <>
      {canSeeImputationDetails && (
        <Label
          label="Tipo y objeto de imputación"
          onClick={setOpenModal}
          size="md"
          sizeValue="lg"
          value="VER DETALLES"
          variant="light"
        />
      )}

      <WorkReportLineMenu setShowModalMenu={setShowModalMenu} showModalMenu={showModalMenu} />
      <div
        className="three-points-menu "
        style={{
          display: !showModalMenu ? 'none' : 'block',
          width: isOrderByUbication ? '138px' : '170px'
        }}
      >
        <ul className="options-line-menu shadow">
          <li>
            <button
              className="buttons-line-menu"
              disabled={disabledDeleteAction}
              onClick={() => {
                handleUpdateDeleteUbicationInfo();
                setShowDeleteModal(true);
                setShowModalMenu(false);
              }}
              type="button"
            >
              {isOrderByUbication ? 'Eliminar ubicación' : 'Eliminar posición-línea'}
            </button>
          </li>
          {isOrderByUbication && (
            <li>
              <button
                className="buttons-line-menu"
                disabled={!isFinishedServiceAvailable}
                onClick={() => {
                  handleSetFinishedServiceInfo();
                  setShowFinishedServiceModal(true);
                  setShowModalMenu(false);
                }}
                type="button"
              >
                Finalizar servicio
              </button>
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

RightContentAccordion.propTypes = {
  byUbication: PropTypes.bool,
  disabledDeleteAction: PropTypes.bool.isRequired,
  IOPermissions: TypeAndObjectImputationPermissions.isRequired,
  isOrderByUbication: PropTypes.bool.isRequired,
  setOpenModal: PropTypes.func,
  setShowDeleteModal: PropTypes.func.isRequired,
  handleUpdateDeleteUbicationInfo: PropTypes.func,
  handleSetFinishedServiceInfo: PropTypes.func,
  setShowFinishedServiceModal: PropTypes.func,
  isFinishedServiceAvailable: PropTypes.bool
};

RightContentAccordion.defaultProps = {
  byUbication: false,
  setOpenModal: () => {},
  isFinishedServiceAvailable: false,
  handleUpdateDeleteUbicationInfo: () => {},
  handleSetFinishedServiceInfo: () => {},
  setShowFinishedServiceModal: () => {}
};

export default RightContentAccordion;
